import { render, staticRenderFns } from "./add-edit-user.vue?vue&type=template&id=0c7451ea&scoped=true&"
import script from "./add-edit-user.vue?vue&type=script&lang=js&"
export * from "./add-edit-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7451ea",
  null
  
)

export default component.exports